import React from "react";
import { format, setHours } from "date-fns";
import { fr } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import strings from "../../helpers/Localization";

import Inputs from "../Inputs/Inputs";
import TextField from "../Inputs/TextField";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import Modal from "../Modal/Modal";

const pastMonth = new Date();
const modifiersStyles = {
    selected: {
        backgroundColor: "var(--primary-medium)" // Style for the selected date
    },
    start: {
        backgroundColor: "var(--primary-base)" // Style for the start date
    },
    end: {
        backgroundColor: "var(--primary-base)" // Style for the end date
    }
};
const customWeekDays = ["D", "L", "M", "M", "J", "V", "S"];
const currentDate = new Date();
const tomorrow = new Date(currentDate);
tomorrow.setDate(currentDate.getDate() + 1);
const dateInOneYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
const cdisabledDays = [
    { from: tomorrow, to: dateInOneYear }
];

const DateTimePicker = ({ open, onClose, title, onValidate, currentValue, blockFutureDates, disabledDays }) => {
    const [selected, setSelected] = React.useState(currentDate);
    const [hourValue, setHourValue] = React.useState(String(currentDate.getHours()).padStart(2, "0"));
    const [minuteValue, setMinuteValue] = React.useState(String(currentDate.getMinutes()).padStart(2, "0"));
    const parsedValue = React.useRef({
        calendarDate: currentDate,
        hour: hourValue,
        minute: minuteValue
    });

    React.useEffect(() => {
        parsedValue.current = ParseValue(currentValue);
        setSelected(parsedValue.current.calendarDate);
        setHourValue(parsedValue.current.hour);
        setMinuteValue(parsedValue.current.minute);
    }, [currentValue]);

    const Reset = () => {
        setTimeout(() => {
            setSelected(null);
        }, 2000);
    };
    const ParseValue = (value) => {
        const stringDateTime = value;
        let calendarDate = currentDate;
        if (stringDateTime !== undefined && stringDateTime !== null) {
            calendarDate = new Date(dayjs(stringDateTime).format("YYYY-MM-DD HH:mm"));
        }
        const parsed = {
            calendarDate: calendarDate,
            hour: String(calendarDate.getHours()).padStart(2, "0"),
            minute: String(calendarDate.getMinutes()).padStart(2, "0")
        };
        return parsed;
    };

    return <Modal open={open}
        // widthModalPaper={"365px"}
        widthModalPaper={"400px"}
        heightModalBody={"475px"}
        onClose={() => {
            Reset();
            onClose();
        }}
        onValidate={() => {
            const newDate = parsedValue.current.calendarDate;
            newDate.setHours(Number(parsedValue.current.hour), Number(parsedValue.current.minute), 0, 0);
            onValidate(newDate);
            Reset();
        }}
        title={title ? title : strings.dateTime}
        icon={"calendar"}
    >
        <DayPicker
            id="date-picker-modal"
            locale={{
                ...fr,
                localize: {
                    ...fr.localize,
                    day: (n) => customWeekDays[n]
                }
            }}
            mode="single"
            defaultMonth={pastMonth}
            showOutsideDays
            selected={selected}
            onSelect={(newDate) => {
                if (newDate) {
                    if (parsedValue.current.time) {
                        newDate.setHours(Number(parsedValue.current.time.slice(0, 2)), Number(parsedValue.current.time.slice(3, 5)), 0, 0);
                    }
                    parsedValue.current.calendarDate = newDate;
                    setSelected(newDate);
                }
            }}
            modifiersStyles={modifiersStyles}
            disabled={ disabledDays ? disabledDays : blockFutureDates ? cdisabledDays : null}
            //modifiers={{ start: range.from, end: range.to }}
        />
        <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
            <Inputs field={{ type: "divider" }}/>
        </div>

        <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "10px", alignItems: "center", justifyItems: "center" }}>
            <TextField
                placeholder={"00"}
                value={hourValue}
                textAlign={"center"}
                maxWidth={130}
                onChange={(e) => {
                    let number = Number(e.target.value);
                    if (!number && number !== 0) {return;}
                    if (number < 0) {return;}
                    if (number > 23) {
                        //we keep only the unit (last entered) value
                        number = number - Math.floor(number / 10) * 10;
                    }
                    const value = String(number).padStart(2, "0");
                    setHourValue(value);
                    parsedValue.current.hour = value;
                }}
            />
            <span style={{ diplay: "flex" }}>:</span>
            <TextField
                placeholder={"00"}
                value={minuteValue}
                textAlign={"center"}
                maxWidth={130}
                onChange={(e) => {
                    let number = Number(e.target.value);
                    if (!number && number !== 0) {return;}
                    if (number < 0) {return;}
                    if (number > 59) {
                        //we keep only the unit (last entered) value
                        number = number - Math.floor(number / 10) * 10;
                    }
                    const value = String(number).padStart(2, "0");
                    setMinuteValue(value);
                    parsedValue.current.minute = value;
                }}
            />
        </div>
    </Modal>;
};

export default DateTimePicker;
